import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { UserContextValue } from "@redotech/redo-merchant-app-common/user";

function redoAdminOnly({
  user,
}: {
  user: NonNullable<UserContextValue>;
}): boolean {
  return isRedoEmailAddress(user.email);
}

export const plgProductsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Products", permission: redoAdminOnly },
    children: [
      {
        index: true,
        async lazy() {
          const { PlgProductsPage } =
            await import("../../../plg/plg-products-page");
          return { Component: PlgProductsPage };
        },
      },
    ],
  },
];
